import {
  EngineResponse,
  ProductMain,
  ProductType,
  SanityProductPreset,
} from "@sourceful/shared-types";
import { generateShopStructuredMarkup } from "../helpers";
import env from "@lib/utils/env";
import { useRouter } from "next/router";

const BASE_URL = env("BASE_URL");

export interface GoogleShopStructuredMarkupProps {
  selectedPreset: SanityProductPreset | null;
  product: ProductMain;
  rfqFromPriceInPence: number;
  engineMetadata: EngineResponse | null;
}

const GoogleShopStructuredMarkup = ({
  selectedPreset,
  product,
  engineMetadata,
  rfqFromPriceInPence,
}: GoogleShopStructuredMarkupProps) => {
  const isRFQ = product.type === ProductType.RFQ;
  const router = useRouter();
  const unitPriceRaw =
    engineMetadata?.results?.price_amount?.price_per_unit_pence ?? rfqFromPriceInPence;

  if (isRFQ && !rfqFromPriceInPence) {
    return null;
  }

  if (!isRFQ && !engineMetadata) {
    return null;
  }

  const googleShopData = generateShopStructuredMarkup(
    selectedPreset,
    product,
    unitPriceRaw,
    `${BASE_URL}${router.asPath}`
  );

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(googleShopData) }}
    />
  );
};

export default GoogleShopStructuredMarkup;
